import type { Filter } from 'components/filters/useStreamFilters'
import type { Quest } from 'types/quests'

type NewThreadDraftContext = {
    questId?: string
    newThread?: boolean
    draftFilter?: Filter
}

type NewThreadDraftRecoveryDependencies = {
    getCachedQuest: (questId: string) => Quest | null
    createDraft: (questId: string, filter: Filter) => Quest
    cacheQuest: (quest: Quest) => Quest | null
}

type NewThreadPanel = {
    panelId: string
    newThread?: boolean
} | null

type EditPanel = (panelId: string, values: { newThread: false; draftFilter: undefined }) => void

export function ensureNewThreadDraft(
    { questId, newThread, draftFilter }: NewThreadDraftContext,
    dependencies: NewThreadDraftRecoveryDependencies,
) {
    if (!newThread || !questId) return null

    const existingDraft = dependencies.getCachedQuest(questId)
    if (existingDraft) return existingDraft

    const recoveredDraft = dependencies.createDraft(questId, draftFilter || { private: true })
    dependencies.cacheQuest(recoveredDraft)
    return recoveredDraft
}

export function clearPublishedNewThreadContext(panel: NewThreadPanel, editPanel: EditPanel) {
    if (!panel?.newThread) return false

    editPanel(panel.panelId, { newThread: false, draftFilter: undefined })
    return true
}
